import React, { useMemo } from 'react';
import CalendarUtils from 'services/CalendarUtils';
import moment from 'moment-timezone';
import { DatePicker } from 'antd';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Icon from '../Icon';

const DEFAULT_STYLE = { display: 'inline-block' };

const DefaultDatePicker = ({
  id,
  label,
  value,
  onChange,
  disabled,
  style = DEFAULT_STYLE,
  small,
  field,
  className,
  bordered = false,
  ref = null,
  forceLabel = false,
  autoFocus,
  convertToTargetTimezone = true,
}) => {
  function onChangeWrapper(date) {
    let unix = date;
    if (convertToTargetTimezone) {
      let datetime = CalendarUtils.convertToTargetTimezone(date);
      unix = datetime;
    }
    unix = unix.unix();
    if (field) field.input.onChange(unix);
    if (onChange) onChange({}, unix);
  }

  const formattedValue = useMemo(() => {
    let converted = value || (field ? field.input.value : undefined);
    if (!converted) return null;
    converted = moment.unix(converted).utc();
    converted.hour(12);
    return CalendarUtils.convertFromTargetTimezone(converted);
  }, [field, value]);

  let chosenId = (field || {}).id || id || 'date-field';
  let chosenStyle = (field || {}).style || style;
  let chosenLabel = (field || {}).label || label;
  let chosenDisabled = (field || {}).disabled || disabled;
  let chosenSmall = (field || {}).small || small;
  let chosenClassName = (field || {}).className || className;

  let pickerClassName = 'default-date-picker';
  if (chosenSmall) pickerClassName += ' small';
  if (chosenClassName) pickerClassName += ' ' + chosenClassName;
  if (forceLabel) pickerClassName += ' force-label';

  let error = !!field && field.meta.dirty ? field.meta.error : undefined;

  return (
    <FormControl focused={true} className={pickerClassName} style={chosenStyle} error={!!error}>
      {!!chosenLabel && !chosenSmall && <InputLabel>{chosenLabel}</InputLabel>}
      <DatePicker
        autoFocus={autoFocus}
        ref={ref}
        id={chosenId}
        allowClear={false}
        disabled={chosenDisabled}
        bordered={bordered || field?.bordered}
        defaultValue={formattedValue}
        format="YYYY/MM/DD"
        onSelect={onChangeWrapper}
        onChange={onChangeWrapper}
      />
      {!!error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default DefaultDatePicker;
